(function () {
    'use strict';

    var module = angular.module('uwAgenda.help');
    module.filter('HelpFilter', [HelpFilterFn]);

    function HelpFilterFn() {
        return function (items, searchValue, category) {
            var results = [];
            var searchValueLow = searchValue.toLowerCase().replace('*', '');

            // always filter lang & category
            items.forEach(function (item) {
                if (item.content !== null) {
                    // search caption and content for language
                    // superadmin sees all languages and can filter by language
                    if ((item.caption.toLowerCase().indexOf(searchValueLow) !== -1
                        || item.content.toLowerCase().indexOf(searchValueLow) !== -1
                        //($rootScope.isRingfoonAdmin && item.language.caption.toLowerCase().indexOf(searchValue) !== -1)
                        ) && item.category === category
                        ) {
                        results.push(item);
                    } // if
                } // if
            });

            return results;
        };
    }
})();
